// Fase 27A-F: cliente HTTP mínimo de recuperación de contraseña (endpoints públicos). No dispara el
// refresh/eventos de sesión tenant.
const API_BASE_URL = (import.meta.env.VITE_API_URL || 'http://localhost:3000').replace(/\/$/, '');

export class RecoveryApiError extends Error {
  constructor(public readonly status: number, message: string, public readonly code?: string) {
    super(message);
    this.name = 'RecoveryApiError';
  }
}

async function req<T>(path: string, body: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`${API_BASE_URL}${path}`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  } catch {
    throw new RecoveryApiError(0, 'No fue posible conectar con el servidor.');
  }
  const text = await res.text();
  const payload = text ? JSON.parse(text) : undefined;
  if (!res.ok) {
    const p = (payload ?? {}) as { message?: string; error?: string };
    throw new RecoveryApiError(res.status, p.message || 'Ocurrió un error.', p.error);
  }
  return payload as T;
}

export const forgotPassword = (email: string) => req<{ message: string }>('/api/auth/forgot-password', { email });
export const resetPassword = (token: string, newPassword: string) => req<{ ok: boolean; message: string }>('/api/auth/reset-password', { token, newPassword });
